import { render, staticRenderFns } from "./ReasonSelectorPreviewText.vue?vue&type=template&id=fd1e0a40&scoped=true&"
import script from "./ReasonSelectorPreviewText.vue?vue&type=script&lang=js&"
export * from "./ReasonSelectorPreviewText.vue?vue&type=script&lang=js&"
import style0 from "./ReasonSelectorPreviewText.vue?vue&type=style&index=0&id=fd1e0a40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1e0a40",
  null
  
)

export default component.exports